import * as types from 'store/actions/types';
import produce from 'immer';

const INITIAL_STATE = {
	data: [],
	isLoaded: false,
	error: false
};

export default (state = INITIAL_STATE, action) =>
	produce(state, (draft) => {
		switch (action.type) {
			// ****************** CLEAR DATA ******************
			case types.CLEAR_STATE:
				return { ...INITIAL_STATE };

			// *************** FETCH SECTIONS ASSIGNED ***************
			case types.FETCH_SECTIONS_ASSIGNED_LOADING:
				draft.isLoaded = false;
				draft.error = false;
				return;

			case types.FETCH_SECTIONS_ASSIGNED_SUCCESS:
				draft.isLoaded = true;
				draft.data = action.payload;
				return;

			case types.FETCH_SECTIONS_ASSIGNED_ERROR:
				draft.isLoaded = true;
				draft.error = true;
				return;

			default:
				return state;
		}
	});
